module.exports = __webpack_public_path__ + "static/media/antoni_kepinski.2b2232b8.png";